import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { StatsAndTestimonials } from './components/StatsAndTestimonials';
import { PainPoints } from './components/PainPoints';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
const PIXEL_ID = '904978025482552';
function loadFacebookPixel() {
  if ((window as any).fbq) return;
  const f = window as any;
  const b = document;
  const e = 'script';
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  const t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = b.getElementsByTagName(e)[0];
  s?.parentNode?.insertBefore(t, s);
  f.fbq('init', PIXEL_ID);
  f.fbq('track', 'PageView');
  const noscriptImg = b.createElement('img');
  noscriptImg.height = 1;
  noscriptImg.width = 1;
  noscriptImg.style.display = 'none';
  noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
  b.body.appendChild(noscriptImg);
}
export function App() {
  useEffect(() => {
    // SEO & Performance Meta Tags
    document.documentElement.lang = 'es';
    document.title = 'Mega Pack Auto Blindado™ — El pack más completo para dueños de auto usado | Auto Blindado';
    const addMeta = (attr: string, attrValue: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    // Core SEO
    addMeta('name', 'description', 'Mega Pack Auto Blindado™ — El sistema N°1 para dueños de auto usado en Argentina. 6 módulos + 5 bonos. Defendete de multas, mecánicos y sorpresas. Acceso inmediato.');
    // Canonical
    if (!document.querySelector('link[rel="canonical"]')) {
      const canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = 'https://autoblindado.fegion.shop/';
      document.head.appendChild(canonical);
    }
    // Open Graph
    const ogImage = 'https://cdn.magicpatterns.com/uploads/uCWpeHpbN1twnajUnKBrpq/Diseno_sin_titulo_(1)_(1).png';
    addMeta('property', 'og:type', 'website');
    addMeta('property', 'og:locale', 'es_AR');
    addMeta('property', 'og:url', 'https://autoblindado.fegion.shop/');
    addMeta('property', 'og:title', 'Mega Pack Auto Blindado™ — El sistema N°1 para dueños de auto usado');
    addMeta('property', 'og:description', 'Todo lo que necesitás para mantener tu auto, defenderte de multas y no volver a depender de mecánicos. 6 módulos + 5 bonos. Acceso inmediato.');
    addMeta('property', 'og:image', ogImage);
    addMeta('property', 'og:site_name', 'Auto Blindado');
    // Twitter Card
    addMeta('name', 'twitter:card', 'summary_large_image');
    addMeta('name', 'twitter:title', 'Mega Pack Auto Blindado™ — El sistema N°1 para dueños de auto usado');
    addMeta('name', 'twitter:description', 'Todo lo que necesitás para mantener tu auto, defenderte de multas y no volver a depender de mecánicos.');
    addMeta('name', 'twitter:image', ogImage);
    // JSON-LD Structured Data
    if (!document.querySelector('script[data-schema="product"]')) {
      const jsonLd = document.createElement('script');
      jsonLd.type = 'application/ld+json';
      jsonLd.setAttribute('data-schema', 'product');
      jsonLd.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'Mega Pack Auto Blindado™',
        description: 'El sistema N°1 para dueños de auto usado en Argentina. 6 módulos + 5 bonos estratégicos incluidos.',
        image: ogImage,
        brand: {
          '@type': 'Brand',
          name: 'Auto Blindado'
        },
        offers: [{
          '@type': 'Offer',
          name: 'Mega Pack Auto Blindado™',
          price: '19990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: 'https://autoblindado.fegion.shop/'
        }, {
          '@type': 'Offer',
          name: 'Mega Pack + Mecánica de Guerra 24/7™',
          price: '29990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: 'https://autoblindado.fegion.shop/'
        }],
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          bestRating: '5',
          reviewCount: '800'
        }
      });
      document.head.appendChild(jsonLd);
    }
    // Preconnect links
    const addPreconnect = (href: string, crossOrigin = false) => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = href;
        if (crossOrigin) link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    };
    addPreconnect('https://fonts.googleapis.com');
    addPreconnect('https://fonts.gstatic.com', true);
    addPreconnect('https://cdn.magicpatterns.com', true);
    // Preload LCP image immediately
    const heroImgUrl = 'https://cdn.magicpatterns.com/uploads/uCWpeHpbN1twnajUnKBrpq/Diseno_sin_titulo_(1)_(1).png';
    if (!document.querySelector(`link[href="${heroImgUrl}"]`)) {
      const preload = document.createElement('link');
      preload.rel = 'preload';
      preload.as = 'image';
      preload.href = heroImgUrl;
      preload.setAttribute('fetchpriority', 'high');
      document.head.appendChild(preload);
    }
    // Load Google Fonts AFTER first paint to avoid render-blocking
    // Double rAF ensures the first paint completes before adding the stylesheet
    const loadFonts = () => {
      const fontsUrl = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Oswald:wght@600;700&display=swap';
      if (!document.querySelector(`link[href*="fonts.googleapis.com/css2"]`)) {
        const fontLink = document.createElement('link');
        fontLink.rel = 'stylesheet';
        fontLink.href = fontsUrl;
        document.head.appendChild(fontLink);
      }
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(loadFonts);
    });
  }, []);
  // Defer Facebook Pixel to reduce TBT - load after page is interactive
  useEffect(() => {
    const timer = setTimeout(() => {
      if ('requestIdleCallback' in window) {
        ;
        (window as any).requestIdleCallback(loadFacebookPixel);
      } else {
        loadFacebookPixel();
      }
    }, 3500);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-background text-gray-300 font-body selection:bg-cyan selection:text-background" data-id="element-0">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-cyan focus:text-background focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold focus:outline-none" data-id="element-1">
        Saltar al contenido principal
      </a>
      <main id="main-content" data-id="element-2">
        <Hero data-id="element-3" />
        <StatsAndTestimonials data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Modules data-id="element-6" />
        <Bonuses data-id="element-7" />
        <Pricing data-id="element-8" />
        <CostComparison data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <PurchaseToast data-id="element-12" />
    </div>;
}